import React from "react";
import Blogs from "./components/Blogs/Blogs";
import Certificates from "./components/Certificates/Certificates";
import EmailBox from "./components/EmailBox";
import Expertise from "./components/Expertise";
import Footer from "./components/Footer";
import Latestprojects from "./components/LatestProjects";
import Qualification from "./components/Qualification";
import Specializing from "./components/Specializing";
import Top from "./components/Top/Top";

const Home = () => {
  return (
    <>
      <Top />
      <div style={{ backgroundColor: "#fff" }}>
        <Specializing />

        <Latestprojects />
        <Expertise />
        <Blogs/>
        <Certificates />
     {/*    <Qualification /> */}

        <EmailBox />

        <Footer />
      </div>
    </>
  );
};

export default Home;
